// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"867":"b8c53be3","1378":"c567b8af","2717":"0a481e92","3051":"13271446","5576":"a766a904","5770":"a8e04ecd","6264":"33f50ac7","8515":"4e0f7e65"}[chunkId] + ".chunk.css";
};